import config from "../config/app";
import {
  DATA_MODEL_VERSION_OVERRIDE,
  MIGRATION_TYPE_BACKUP,
  MIGRATION_TYPE_SHARED,
} from "../constants/MigrationConstants";
import SiteService from "../service/SiteService.mjs";

/**
 * Sets the design version override in session storage
 * @param {int} version - the version to override to
 */
export const setDesignVersionOverride = (version) => {
  if (version !== config.dataModelVersion) {
    sessionStorage.setItem(DATA_MODEL_VERSION_OVERRIDE, version);
  } else if (getDesignVersionOverride()) removeDesignVersionOverride();
};

/**
 * Removes the design version override from session storage
 */
export const removeDesignVersionOverride = () =>
  sessionStorage.removeItem(DATA_MODEL_VERSION_OVERRIDE);

/**
 * Gets the design version override from session storage
 */
export const getDesignVersionOverride = () => sessionStorage.getItem(DATA_MODEL_VERSION_OVERRIDE);

/**
 * Checks if the current design version matches the version passed in
 * @param {int} version - the version to check against
 */
export const isCorrectVersion = (version = 1) => version === getCurrentDesignVersion();

/**
 * Gets the current design version respecting any overrides
 */
export const getCurrentDesignVersion = () => {
  const versionOverride = getDesignVersionOverride();
  return versionOverride !== null ? +versionOverride : config.dataModelVersion;
};

/**
 * Migrates the design to the requested version
 * @param {string} key - the s3 key of the design to migrate
 * @param {string} migrationType - the type of migration to perform
 * @param {boolean} [force] - whether or not to force the migration
 * @see MIGRATION_TYPE_PRIMARY
 * @see MIGRATION_TYPE_BACKUP
 * @see MIGRATION_TYPE_SHARED
 * @see MIGRATION_TYPE_PREVIEW
 */
export const migrateDesign = ({ key, migrationType, force }) => {
  const params = {
    requestedVersion: getCurrentDesignVersion(),
    key: key.split("/")[0],
    migrationType,
    force,
  };
  if (migrationType === MIGRATION_TYPE_SHARED || migrationType === MIGRATION_TYPE_BACKUP)
    params.pubKey = key;
  return SiteService.migrateDesign(params);
};

export default {
  isCorrectVersion,
  migrateDesign,
  getDesignVersionOverride,
  setDesignVersionOverride,
  removeDesignVersionOverride,
  getCurrentDesignVersion,
};
